import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRootStore } from '../../../../../providers/root-store-provider';
import { AddTradesOnboardingSubcaseEnum } from '../../../../../models/enums/add-trades-onboarding-subcase-enum';
import { Button } from '../../../form/button/button';
import { OnboardingFooter } from '../../footer/onboarding-footer';
import { Headline } from '../../../headline/headline';
import { IconDownload } from '../../../icons/download';
import { IconPlus } from '../../../icons/plus';

export const AddTradesStartContent = () => {
    const { t } = useTranslation();
    const { onboardingStore } = useRootStore();

    return (
        <>
            <Headline level={3} tag={'div'} gap={'vsmall'} marginTop={'none'}>
                {t('layout.onboarding.addTrades.headline')}
            </Headline>

            {t('layout.onboarding.addTrades.start')}
            <OnboardingFooter direction={'column'}>
                <Button
                    variant="positive"
                    variation={'outlined'}
                    onClick={() => {
                        onboardingStore.setAddTradesSubcase(AddTradesOnboardingSubcaseEnum.import);
                    }}
                    block
                    size={{ xs: 'vsmall', vl: 'medium' }}
                    icon={<IconDownload />}
                >
                    {t('layout.onboarding.addTrades.startImport')}
                </Button>
                <Button
                    variant="primary"
                    variation={'outlined'}
                    block
                    icon={<IconPlus />}
                    onClick={() => {
                        onboardingStore.setAddTradesSubcase(AddTradesOnboardingSubcaseEnum.manual);
                    }}
                    size={{ xs: 'vsmall', vl: 'medium' }}
                >
                    {t('layout.onboarding.addTrades.startManual')}
                </Button>
            </OnboardingFooter>
        </>
    );
};
